import { motion } from "framer-motion";

const HERO_IMG =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_asilo-peramore/artifacts/q3k5su82_06573af1-c34e-4581-8eea-c14ed5e206b1.jpeg";

export const Hero = () => {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="hero" data-testid="hero-section" className="relative h-[88vh] min-h-[560px] w-full">
      <img src={HERO_IMG} alt="Asilo Nido Per Amore" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/40 via-slate-900/30 to-slate-900/60" />

      <div className="relative h-full flex flex-col items-center justify-center text-center px-6">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="font-heading text-white/95 text-lg sm:text-2xl font-500 tracking-wide"
        >
          Benvenuti all'Asilo Nido
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.1, ease: "backOut" }}
          className="font-brand text-white text-6xl sm:text-8xl md:text-9xl leading-none drop-shadow-lg"
        >
          Per Amore
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="mt-5 max-w-xl text-white/90 font-600 text-base sm:text-lg"
        >
          Un luogo dove ogni giorno nasce una nuova scoperta, un nuovo sorriso e
          un nuovo ricordo da custodire.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.4 }}
          className="mt-8 flex flex-wrap gap-4 justify-center"
        >
          <button
            data-testid="hero-cta-chi-siamo"
            onClick={() => go("chi-siamo")}
            className="rounded-full bg-rose-500 text-white px-8 py-3.5 font-700 hover:bg-rose-600 hover:-translate-y-0.5 transition-all shadow-lg"
          >
            Scopri chi siamo
          </button>
          <button
            data-testid="hero-cta-contatti"
            onClick={() => go("contatti")}
            className="rounded-full bg-white/90 text-slate-800 px-8 py-3.5 font-700 hover:bg-white hover:-translate-y-0.5 transition-all shadow-lg"
          >
            Contattaci
          </button>
          <div className="basis-full flex justify-center">
            <button
              data-testid="hero-cta-richiedi-info"
              onClick={() => go("richiedi-info")}
              className="rounded-full bg-amber-400 text-slate-900 px-6 py-2.5 text-sm font-800 hover:bg-amber-300 hover:-translate-y-0.5 transition-all shadow-lg"
            >
              Richiedi informazioni · Compila il modulo!
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
